module.exports = __webpack_public_path__ + "img/box_pro_three_1.1992d8bd.jpg";